import { withStyles } from '@mui/styles';

import muiStyles from './styles';
import ThemeRefreshModal from './themeRefreshModal';

export default withStyles(muiStyles)(ThemeRefreshModal);